var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5123_1686)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5123_1686)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21 41.7578C32.0457 41.7578 41 32.8035 41 21.7578C41 10.7121 32.0457 1.75781 21 1.75781C9.9543 1.75781 1 10.7121 1 21.7578C1 32.8035 9.9543 41.7578 21 41.7578Z",
    stroke: "#F9F5EA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5414 29.9277H21.8008V22.3301H24.2083L24.6898 19.261H21.8008V16.9405C21.8008 16.0797 22.6159 15.5933 23.3933 15.5933H24.8008V13.0482L22.2822 12.936C19.8747 12.7862 18.5414 14.695 18.5414 16.978V19.261H15.8008V22.3301H18.5414V29.9277Z",
    fill: "#F9F5EA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5123_1686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(0 0.757812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5123_1686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(0 0.757812)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebookIcon.34b00b8dbad96fbb3d5c169ba3f57881.svg";
export { ForwardRef as ReactComponent };